<template>
  <div>
    <div>
      <h2>Reports</h2>
    </div>
    <div class="stats-panel">
      <div class="stats-panel__column">
        <h3 class="stats-panel__heading">Monthly Summary</h3>
        <div class="stats-panel__content">
          <div class="stats-panel__fields">
            <select v-model="selectedMonth">
              <option v-for="option in monthOptions" :key="option.value" :value="option.value">{{ option.name }}</option>
            </select>
            <select v-model="selectedYear" style="flex-grow: 0; width: unset;">
              <option v-for="option in yearOptions" :key="option.value" :value="option.value">{{ option.name }}</option>
            </select>
          </div>
        </div>
        <div class="stats-panel__button">
          <button class="btn btn-plain-primary" style="margin-top: 20px;" @click="handleDownloadMonthlyPdfCallback">
            <span v-if="downloadingMonthly" class="pickstar-loading"></span>
            <span v-else><i class="fa fa-cloud-download"></i>&nbsp;Download </span>
          </button>
        </div>
      </div>

      <div class="stats-panel__column">
        <h3 class="stats-panel__heading">Annual Report</h3>
        <div class="stats-panel__content">
          <div class="stats-panel__fields">
            <select v-model="selectedYearYearly">
              <option v-for="option in yearOptions" :key="option.value" :value="option.value">{{ option.name }}</option>
            </select>
          </div>
        </div>
       <div class="stats-panel__button">
          <button class="btn btn-plain-primary" style="margin-top: 20px;" @click="handleDownloadYearlyPdfCallback">
            <span v-if="downloadingYearly" class="pickstar-loading"></span>
            <span v-else><i class="fa fa-cloud-download"></i>&nbsp;Download </span>
          </button>
        </div>
      </div>

      <div class="stats-panel__column">
        <h3 class="stats-panel__heading">Custom Range</h3>
        <div class="stats-panel__content">
          <span>Template: </span>
          <select v-model="selectedTemplate" style="margin-bottom: 10px;">
            <option v-for="option in templateOptions" :key="option.value" :value="option.value">{{ option.name }}</option>
          </select>
          <div class="stats-panel__fields">
            <flatpickr
              v-model="dateRange"
              :config="flatPickerDateConfig"
              class="form-control"
              placeholder="Please Select"
              name="date"/>
          </div>
        </div>
        <div class="stats-panel__button">
          <button class="btn btn-plain-primary" style="margin-top: 10px;" @click="handleDownloadCustomPdfCallback">
            <span v-if="downloadingCustom" class="pickstar-loading"></span>
            <span v-else><i class="fa fa-cloud-download"></i>&nbsp;Download </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import ProfileTalentTagline from './ProfileTalentTagline'
import ProfileTalentSocialMedia from './ProfileTalentSocialMedia'
import ProfileTalentStats from './ProfileTalentStats'
import Flatpickr from 'vue-flatpickr-component'

export default {
  components: {
    ProfileTalentStats,
    ProfileTalentTagline,
    ProfileTalentSocialMedia,
    Flatpickr
  },

  data () {
    return {
      downloadingYearly: false,
      downloadingMonthly: false,
      downloadingCustom: false,
      selectedMonth: new Date().getMonth() === 0 ? 12 : new Date().getMonth(),
      selectedYear: 2020,
      selectedYearYearly: 2020,
      selectedTemplate: 'monthly',
      endDate: null,
      startDate: null,
      flatPickerDateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range'
      },
      monthOptions: [
        {
          value: 1,
          name: 'January'
        },
        {
          value: 2,
          name: 'February'
        },
        {
          value: 3,
          name: 'March'
        },
        {
          value: 4,
          name: 'April'
        },
        {
          value: 5,
          name: 'May'
        },
        {
          value: 6,
          name: 'June'
        },
        {
          value: 7,
          name: 'July'
        },
        {
          value: 8,
          name: 'August'
        },
        {
          value: 9,
          name: 'September'
        },
        {
          value: 10,
          name: 'October'
        },
        {
          value: 11,
          name: 'November'
        },
        {
          value: 12,
          name: 'December'
        }
      ],
      yearOptions: [
        {
          value: 2019,
          name: '2019'
        },
        {
          value: 2020,
          name: '2020'
        }
      ],
      templateOptions: [
        {
          value: 'monthly',
          name: 'Monthly Player Summary'
        },
        {
          value: 'annual',
          name: 'Annual Player Report'
        }
      ]
    }
  },

  methods: {
    ...mapActions('talent/profile', ['getCustomPdf']),

    handleDownloadYearlyPdfCallback () {
      this.downloadingYearly = true
      return this.getCustomPdf({ id: this.user.id, startDate: (this.selectedYearYearly - 1) + '-10-31', endDate: this.selectedYearYearly + '-11-01', template: 'annual' })
        .then(({ data: { file_url: fileUrl, file, name } }) => {
          window.open(fileUrl, '_blank')
          this.downloadingYearly = false
        })
        .catch(() => {
          this.downloadingYearly = false
        })
    },

    handleDownloadMonthlyPdfCallback () {
      this.downloadingMonthly = true
      const startDate = this.selectedYear + '-' + this.selectedMonth + '-01'
      const endDate = this.selectedYear + '-' + this.selectedMonth + '-31'
      return this.getCustomPdf({ id: this.user.id, startDate: startDate, endDate: endDate, template: 'monthly' })
        .then(({ data: { 'file_url': fileUrl } }) => {
          window.open(fileUrl, '_blank')
          this.downloadingMonthly = false
        })
        .catch(() => {
          this.downloadingMonthly = false
        })
    },

    handleDownloadCustomPdfCallback () {
      this.downloadingCustom = true
      return this.getCustomPdf({ id: this.user.id, startDate: this.startDate, endDate: this.endDate, template: this.selectedTemplate })
        .then(({ data: { 'file_url': fileUrl } }) => {
          window.open(fileUrl, '_blank')
          this.downloadingCustom = false
        })
        .catch(() => {
          this.downloadingCustom = false
        })
    }
  },

  computed: {
    ...mapState('user', ['user']),

    dateRange: {
      get () {
        if (this.endDate === null || this.startDate === null) {
          return null
        }

        return [this.endDate, this.startDate]
      },

      set (value) {
        if (value.indexOf('to') === -1) {
          this.startDate = null
          this.endDate = null
        } else {
          [this.startDate, this.endDate] = value.split(' to ')
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import './src/assets/sass/bootstrap/variables';
  .stats-panel {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    background-color: #f0f0f0;
    padding: 30px 15px;

    &__title {
      width: 100%;
    }
    &__column {
      width: calc(100% / 3);
      display: flex;
      flex-flow: column wrap;
      /*text-align: center;*/
      padding: 0px 30px;
      justify-content: space-between;
    }
    &__heading {
      width: 100%;
      margin-bottom: 30px;
    }
    &__content {
      width: 100%;
      padding-bottom: 30px;
    }

    &__fields {
      display: flex;
      width: 100%;
    }
    select {
      width: 100%;
    }
    &__button {
      margin-top: auto;
    }
  }
</style>
